module.exports = __webpack_public_path__ + "static/personChatbox-372cd3cdb7b8b89f11675f075ec6ece0.png";